import { render, staticRenderFns } from "./FileLegacy.vue?vue&type=template&id=061ecc04&scoped=true"
import script from "./FileLegacy.vue?vue&type=script&lang=js"
export * from "./FileLegacy.vue?vue&type=script&lang=js"
import style0 from "./FileLegacy.vue?vue&type=style&index=0&id=061ecc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ecc04",
  null
  
)

export default component.exports